import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { UpdateOrderWithInvoiceDto } from 'src/app/domain/models/dto/update-order.dto';
import { FileHandle } from 'src/app/shared/directives/file-drop.directive';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-documents-order-inbound',
  templateUrl: './documents-order-inbound.component.html',
  styleUrls: ['./documents-order-inbound.component.scss'],
})
export class DocumentsOrderInboundComponent implements OnInit {
  @Input('loading') loading?: boolean;
  @Input('finality') finality?: FinalitiesDto;
  @Output('goBack') goBack: EventEmitter<any> = new EventEmitter();
  @Output('sendFile') sendFile: EventEmitter<UpdateOrderWithInvoiceDto> =
    new EventEmitter();
  @Output('closeModal') closeModal: EventEmitter<any> = new EventEmitter();
  isMobile = false;

  selectedFiles: FileHandle[] = [];
  dueProtocol = '';
  dueNumber = '';
  fileOver: boolean;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    private bottomSheet: MatBottomSheet,
    private readonly accountService: AuthenticationService
  ) {
    this.matIconRegistry.addSvgIcon(
      'cloud-upload',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/icons/cloud-upload.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'file',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/image/document-icon.svg'
      )
    );
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 820 ? true : false;
  }

  close() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.closeModal.emit(true);
    }
  }

  filesDropped(files: FileHandle[]): void {
    this.selectedFiles = files;
  }

  selectFile(event: any) {
    this.selectedFiles.push({
      file: event.target.files[0],
      url: this.domSanitzer.bypassSecurityTrustUrl(
        window.URL.createObjectURL(event.target.files[0])
      ),
    });
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  back() {
    this.goBack.emit(true);
  }

  submit() {
    const updateOrder = new UpdateOrderWithInvoiceDto();

    updateOrder.finalityId = null;
    updateOrder.orderId = null;
    updateOrder.files = this.selectedFiles;
    updateOrder.dueNumber = this.dueNumber;
    updateOrder.dueProtocol = this.dueProtocol;
    this.sendFile.emit(updateOrder);
  }
}
